var map = {
	"./4PX.png": "712f",
	"./AliExpress.png": "dc5b",
	"./AmazonMws.png": "c97a",
	"./AmazonShipping+AmazonMCF.png": "046b",
	"./AsendiaUSA.png": "885b",
	"./AustraliaPost.png": "56ca",
	"./CNE.png": "215d",
	"./Cainiao.png": "ef99",
	"./CanadaPost.png": "4457",
	"./ChinaPost.png": "7fab",
	"./CorreosExpress.png": "eb7b",
	"./DHL.png": "08ad",
	"./DHLGlobalMail.png": "2a4f",
	"./DHLeCommerceUS.png": "b056",
	"./FIRSTLINE.png": "51bb",
	"./FedEx.png": "4987",
	"./FedExSmartPost.png": "e0e1",
	"./FirstMile.png": "35e9",
	"./Frame 3.png": "ade5",
	"./Frame 7.png": "e7eb",
	"./Frame 9.png": "07ff",
	"./Gotofreight.png": "1988",
	"./HuaHanLogistics.png": "7daf",
	"./JIAYOUEXP.png": "280a",
	"./JS.png": "2758",
	"./LTEXP.png": "3d0e",
	"./LaserShip.png": "20aa",
	"./PitneyBowes.png": "731f",
	"./SDH.png": "83e4",
	"./SPX.png": "8766",
	"./SUNYOU.png": "a1c4",
	"./UPS.png": "ba18",
	"./UPSMailInnovations.png": "15a2",
	"./USPS.png": "a829",
	"./UniUni.png": "1fa2",
	"./YANWEN.png": "7a24",
	"./YunExpress.png": "7fb3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8de2";